export const LOAD_ORDER_ITEMS = 'LOAD_ORDER_ITEMS';
export const SET_ORDER_ITEM_PAGINATION = 'SET_ORDER_ITEM_PAGINATION';
export const TOGGLE_ORDER_ITEM_STATUS = 'TOGGLE_ORDER_ITEM_STATUS';
export const SET_ORDER_ITEM_FILTERS = 'SET_ORDER_ITEM_FILTERS';
export const RESET_ORDER_ITEM_FILTERS = 'RESET_ORDER_ITEM_FILTERS';
export const SHOW_TOGGLE_STATUS_CONFIRMATION_POPUP = 'SHOW_TOGGLE_STATUS_CONFIRMATION_POPUP';
export const HIDE_TOGGLE_STATUS_CONFIRMATION_POPUP = 'HIDE_TOGGLE_STATUS_CONFIRMATION_POPUP';
export const SHOW_PUT_BULK_IN_PRODUCTION_CONFIRMATION_POPUP = 'SHOW_PUT_BULK_IN_PRODUCTION_CONFIRMATION_POPUP';
export const HIDE_PUT_BULK_IN_PRODUCTION_CONFIRMATION_POPUP = 'HIDE_PUT_BULK_IN_PRODUCTION_CONFIRMATION_POPUP';
export const SET_CHECKED_ORDER_ITEMS_PRODUCTION = 'SET_CHECKED_ORDER_ITEMS_PRODUCTION';
export const PUT_BULK_IN_PRODUCTION = 'PUT_BULK_IN_PRODUCTION';
export const SET_ORDER_ITEM_COMMENT = 'SET_ORDER_ITEM_COMMENT';
export const SET_ORDER_ITEM_NEEDED_DATA = 'SET_ORDER_ITEM_NEEDED_DATA';
export const PUSH_REPRINT = 'PUSH_REPRINT';
export const REPRINT_REQUEST = 'REPRINT_REQUEST';
export const LOAD_ORDER_ITEM = 'LOAD_ORDER_ITEM';
export const SET_ORDER_ITEM_PERCENTAGE = 'SET_ORDER_ITEM_PERCENTAGE';
export const EMPTY_ORDER_ITEM = 'EMPTY_ORDER_ITEM';
export const SET_REPRINT_LOADING = 'SET_REPRINT_LOADING';
export const SET_REPRINT_DATA = 'SET_REPRINT_DATA';
